import React, { PropTypes } from 'react';
import { getSiteName, getSitePhone } from '../../utils/url';
import styled from 'styled-components';

const Help = styled.span`
  line-height: 40px;
  margin: 0 16px;
  color: ${props => props.theme.color.base3};
`;

const HelpPhone = styled.span`
  color: ${props => props.theme.color.primary};
`;

const HelpText = ({ style }) => {
  return (
    <Help style={style}>
      Need help? Call {getSiteName()} on <HelpPhone>{getSitePhone()}</HelpPhone>
    </Help>
  );
};
HelpText.propTypes = {
  style: PropTypes.object
};

export default HelpText;



// WEBPACK FOOTER //
// ./src/components/utils/HelpText.js